import { neutral, purple, red, white } from '../common/colors';

const _connectionArrow = {
  fill: white,
  color: neutral['400'],
  width: 2,
  size: 8,
};

const _disconnectCircle = {
  fill: white,
  border: purple['500'],
  width: 2,
  radius: 15,
};

const _lockedCircle = {
  fill: white,
  border: red['500'],
  width: 2,
  radius: 15,
};

export const styles = {
  _connectionArrow,
  _disconnectCircle,
  _lockedCircle,
};
